(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const selector = [
    '#MainContent .orlisse-product-card',
    '#MainContent .amara-review-card',
    '#MainContent .orlisse-ugc-card',
    '#MainContent .orlisse-merch-card',
    '#MainContent .orlisse-home-heading',
    '#MainContent .section__header',
    '#shopify-section-footer .orlisse-footer__column',
    '[data-amara-reveal]'
  ].join(',');

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-orlisse-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -7% 0px' })
    : null;

  let staggerIndex = 0;

  const register = (element) => {
    if (element.dataset.orlisseMotion) return;

    const isCard = element.matches('.orlisse-product-card,.amara-review-card,.orlisse-ugc-card,.orlisse-merch-card');
    const isHeading = element.matches('.orlisse-home-heading,.section__header');
    const isEditorial = element.matches('[data-amara-reveal]');
    element.dataset.orlisseMotion = isCard ? 'card' : isHeading ? 'heading' : isEditorial ? 'editorial' : 'section';

    if (isCard) {
      element.style.setProperty('--orlisse-motion-delay', `${(staggerIndex % 4) * 70}ms`);
      staggerIndex += 1;
    }

    if (observer) observer.observe(element);
    else element.classList.add('is-orlisse-visible');
  };

  const scan = (root = document) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;
    if (root !== document && root.matches?.(selector)) register(root);
    root.querySelectorAll(selector).forEach(register);
  };

  scan();
  requestAnimationFrame(() => {
    document.body.classList.add('orlisse-motion-ready');
    document.documentElement.classList.remove('orlisse-motion-pending');
  });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => scan(node)));
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
